import React from "react";
import analystTemplate from "./../../../hoc/analystTemplate";
import { Link } from "react-router-dom";

class AnalystDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dashboardData: {
        companies: 0,
        users: 0,
        brands: 0,
      },
      approvedReport: [],
    };
  }

  componentDidMount() {
    this.getDashboard();
    this.getApprovedReport();
  }

  async getDashboard() {
    await window.axios
      .get("/dashboard_v2/client/analyst")
      .then((res) => {
        this.setState({ dashboardData: res.data });
      })
      .catch((error) => {
        //   this.setState({isLoading: false})
      });
  }

  async getApprovedReport() {
    await window.axios
      .get("/dashboard_v2/client/approved-report")
      .then((res) => {
        this.setState({ approvedReport: res.data || [] });
      })
      .catch((error) => {
        //   this.setState({isLoading: false})
      });
  }

  renderCount(value) {
    const n = value || 0;
    if (n === 0) {
      return <span style={{ color: "#cbd2da" }}>&mdash;</span>;
    }
    return (
      <span
        style={{
          display: "inline-block",
          minWidth: 30,
          padding: "2px 9px",
          borderRadius: 12,
          fontWeight: 600,
          fontSize: 12,
          color: "#1b5fbf",
          background: "#e8f1fd",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {n}
      </span>
    );
  }

  renderHtml() {
    const numHeadStyle = {
      textAlign: "right",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: 11,
      fontWeight: 600,
      color: "#90a0b7",
    };
    const labelHeadStyle = {
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: 11,
      fontWeight: 600,
      color: "#90a0b7",
    };
    const numCellStyle = { textAlign: "right" };
    const rows = this.state.approvedReport;
    return (
      <>
        <div className="page-header row no-gutters py-4">
          <div className="col-12">
            <div className="row">
              <div className="col-12 col-sm-4 text-sm-left mb-2">
                <span className="text-uppercase page-subtitle">
                  Analyst Dashboard
                </span>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="row">
              <div className="col-4">
                <div className="card text-white bg-primary o-hidden h-100">
                  <div className="card-body">
                    <div className="card-body-icon">
                      <i className="fa fa-fw fa-user"></i>
                    </div>
                    <div className="mr-5">
                      {this.state?.dashboardData?.users} Users
                    </div>
                  </div>
                  <Link
                    to="/users"
                    className="card-footer text-white clearfix small z-1"
                    href="#"
                  >
                    <span className="float-left">View Details</span>
                    <span className="float-right">
                      <i className="fa fa-angle-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-4">
                <div className="card text-white bg-warning o-hidden h-100">
                  <div className="card-body">
                    <div className="card-body-icon">
                      <i className="fa fa-fw fa-building"></i>
                    </div>
                    <div className="mr-5">
                      {this.state?.dashboardData?.companies} companies
                    </div>
                  </div>
                  <Link
                    to="/companies"
                    className="card-footer text-white clearfix small z-1"
                    href="#"
                  >
                    <span className="float-left">View Details</span>
                    <span className="float-right">
                      <i className="fa fa-angle-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
              <div className="col-4">
                <div className="card text-white bg-success o-hidden h-100">
                  <div className="card-body">
                    <div className="card-body-icon">
                      <i className="fa fa-fw fa-list-ol"></i>
                    </div>
                    <div className="mr-5">
                      {this.state?.dashboardData?.brands} brands
                    </div>
                  </div>
                  <Link
                    to="/brands"
                    className="card-footer text-white clearfix small z-1"
                    href="#"
                  >
                    <span className="float-left">View Details</span>
                    <span className="float-right">
                      <i className="fa fa-angle-right"></i>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 mb-4">
            <div className="card card-small">
              <div className="card-header border-bottom d-flex align-items-center justify-content-between">
                <h6 className="m-0">Client Approval</h6>
                <span
                  className="text-muted"
                  style={{ fontSize: 12, fontWeight: 600 }}
                >
                  {rows.length} {rows.length === 1 ? "brand" : "brands"}
                </span>
              </div>
              <div
                className="card-body p-0 table-responsive"
                style={{ maxHeight: "66vh", overflowY: "auto" }}
              >
                <table
                  className="table table-sm table-hover mb-0"
                  style={{ fontSize: 13 }}
                >
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      background: "#f8fafc",
                    }}
                  >
                    <tr>
                      <th
                        scope="col"
                        className="border-0 py-2 px-3"
                        style={labelHeadStyle}
                      >
                        Company
                      </th>
                      <th
                        scope="col"
                        className="border-0 py-2 px-3"
                        style={labelHeadStyle}
                      >
                        Brand
                      </th>
                      <th
                        scope="col"
                        className="border-0 py-2 px-3"
                        style={numHeadStyle}
                      >
                        Domain
                      </th>
                      <th
                        scope="col"
                        className="border-0 py-2 px-3"
                        style={numHeadStyle}
                      >
                        Social Media
                      </th>
                      <th
                        scope="col"
                        className="border-0 py-2 px-3"
                        style={numHeadStyle}
                      >
                        Website
                      </th>
                      <th
                        scope="col"
                        className="border-0 py-2 px-3"
                        style={numHeadStyle}
                      >
                        App Store
                      </th>
                      <th
                        scope="col"
                        className="border-0 py-2 px-3"
                        style={numHeadStyle}
                      >
                        E-Commerce
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length > 0 ? (
                      rows.map((row, i) => (
                        <tr key={i}>
                          <td
                            className="align-middle px-3 py-2"
                            style={{ fontWeight: 600 }}
                          >
                            {row.company}
                          </td>
                          <td className="align-middle text-muted px-3 py-2">
                            {row.brand}
                          </td>
                          <td
                            className="align-middle px-3 py-2"
                            style={numCellStyle}
                          >
                            {this.renderCount(row.domainCount)}
                          </td>
                          <td
                            className="align-middle px-3 py-2"
                            style={numCellStyle}
                          >
                            {this.renderCount(row.socialMediaCount)}
                          </td>
                          <td
                            className="align-middle px-3 py-2"
                            style={numCellStyle}
                          >
                            {this.renderCount(row.websiteCount)}
                          </td>
                          <td
                            className="align-middle px-3 py-2"
                            style={numCellStyle}
                          >
                            {this.renderCount(row.appStoreCount)}
                          </td>
                          <td
                            className="align-middle px-3 py-2"
                            style={numCellStyle}
                          >
                            {this.renderCount(row.eCommerceCount)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-4">
                          No approved reports yet
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  render() {
    return <>{this.renderHtml()}</>;
  }
}

export default analystTemplate(AnalystDashboard);
